<script setup lang="ts">
import { onBeforeMount, ref, Ref } from "vue";
import { useApiClient } from "@/api/client";
import { minLength, required } from "@/ui/validation/validationRules";
import { useI18n } from "vue-i18n";
import ExportSegmentDO = App.Data.ExportScheduler.ExportSegmentDO;
import SegmentDO = App.Data.Segments.SegmentDO;

const { t } = useI18n();

const exportSegment = defineModel<ExportSegmentDO>();
const availableSegments: Ref<SegmentDO[]> = ref();
const isLoading = ref(false);

const getAvailableSegmentsForUser = async () => {
	isLoading.value = true;
	try {
		const response = await useApiClient("explorer").indexSegments({
			page: 1,
			itemsPerPage: 10000,
			sortBy: [],
		});
		if (response.isOk()) {
			availableSegments.value = response.value.data;
		}
	} finally {
		isLoading.value = false;
	}
};

onBeforeMount(() => {
	getAvailableSegmentsForUser();
});
</script>

<template>
	<div class="segment-export-config d-flex flex-column ga-2">
		<v-skeleton-loader v-if="isLoading" type="article"></v-skeleton-loader>

		<template v-else>
			<!-- Configuration Section -->
			<v-select
				v-model="exportSegment.segment_id"
				:items="availableSegments"
				item-title="title"
				item-value="id"
				label="Segment"
				variant="filled"
				density="comfortable"
				hide-details="auto"
				:rules="[required(t)]"
				placeholder="Select a segment to export"
			/>

			<!-- Email Configuration Section -->
			<div class="d-flex align-center ga-1 mt-4">
				<v-icon icon="mdi-email-outline" size="x-small" />
				<span class="font-weight-medium text-subtitle-2">Email Configuration</span>
			</div>

			<v-text-field
				v-model="exportSegment.email_title"
				label="Subject"
				variant="filled"
				density="comfortable"
				hide-details="auto"
				:rules="[required(t), minLength(t, 10)]"
				placeholder="Enter subject line for the email"
			></v-text-field>

			<v-textarea
				label="Body"
				hide-details="auto"
				variant="filled"
				v-model="exportSegment.email_text"
				:rules="[required(t)]"
			/>
		</template>
	</div>
</template>

<style scoped lang="scss">
.segment-export-config {
	max-width: 100%;
}
</style>
